export const defaultAgeDivisions = [
  {
    value: 'U8',
    label: '8U',
  },
  {
    value: 'U10',
    label: '10U',
  },
  {
    value: 'U12',
    label: '12U',
  },
  {
    value: 'U14',
    label: '14U',
  },
  {
    value: 'U16',
    label: '16U',
  },
  {
    value: 'U18',
    label: '18U',
  },
  {
    value: 'OPEN',
    label: 'Open',
  },
  {
    value: 'O30',
    label: '30+',
  },
  {
    value: 'O35',
    label: '35+',
  },
  {
    value: 'O40',
    label: '40+',
  },
  {
    value: 'O45',
    label: '45+',
  },
  {
    value: 'O50',
    label: '50+',
  },
  {
    value: 'O55',
    label: '55+',
  },
  {
    value: 'O60',
    label: '60+',
  },
  {
    value: 'O65',
    label: '65+',
  },
  {
    value: 'O70',
    label: '70+',
  },
  {
    value: 'O75',
    label: '75+',
  },
  {
    value: 'O80',
    label: '80+',
  },
  {
    value: 'O85',
    label: '85+',
  },
  {
    value: 'O90',
    label: '90+',
  },
  {
    value: 'A',
    label: 'A',
  },
  {
    value: 'B',
    label: 'B',
  },
  {
    value: 'C',
    label: 'C',
  },
  {
    value: 'D',
    label: 'D',
  },
];
